const {
  zipCodeRegexNumeric,
  onlyNumericNormalize,
  SPACE
} = require('../helpers');

exports.zipCodeNormalize = (zipCode) => onlyNumericNormalize(zipCode, 7);

exports.countryDefinition = {
  country: 'Israel',
  code: 'IL',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Street Address' },
    city: { label: 'Town', width: 0.5 },
    zipCode: {
      label: 'Postcode',
      width: 0.5,
      normalize: exports.zipCodeNormalize
    }
  },
  viewFormat: [['company'], ['address'], ['zipCode', SPACE, 'city']],
  formFormat: [['company'], ['address'], ['zipCode', 'city']],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(zipCodeRegexNumeric(7)),
      error: 'Must be 7 numbers, 9414219'
    }
  ]
};
